import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendMessageDialogComponent } from './components/send-message-dialog/send-message-dialog.component';

import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';

import { CommonTranslationModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';



@NgModule({
  declarations: [
    SendMessageDialogComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    TransportInfoPanelModule,
  ]
})
export class SendMessageModule { }
